import { useState } from "react";
import { motion } from "framer-motion";
import { X, Loader2, Ban } from "lucide-react";
import { toast } from "sonner";

const input = "w-full bg-white border border-navy/10 rounded-lg px-3 py-2.5 outline-none focus:border-violet transition-colors text-sm";
const MOTIVOS = [
  ["02", "02 · Comprobante emitido con errores sin relación"],
  ["01", "01 · Comprobante con errores con relación (requiere sustituto)"],
  ["03", "03 · No se llevó a cabo la operación"],
  ["04", "04 · Operación nominativa en factura global"],
];

// props: title, subtitle, onConfirm(motive, substitution) -> Promise, onClose
export default function CancelCFDIModal({ title = "Cancelar CFDI", subtitle, onConfirm, onClose }) {
  const [motive, setMotive] = useState("02");
  const [sub, setSub] = useState("");
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    if (motive === "01" && !sub.trim()) { toast.error("El motivo 01 requiere el UUID del CFDI que sustituye"); return; }
    setBusy(true);
    try { await onConfirm(motive, motive === "01" ? sub.trim() : undefined); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[70] bg-navy/40 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="bg-white rounded-2xl p-6 w-full max-w-md" onClick={(e) => e.stopPropagation()} data-testid="cancel-cfdi-modal">
        <div className="flex items-center justify-between mb-1"><div className="flex items-center gap-2 text-destructive"><Ban className="w-5 h-5" /><h3 className="font-semibold text-navy">{title}</h3></div><button onClick={onClose}><X className="w-5 h-5 text-navy/40" /></button></div>
        {subtitle && <p className="text-xs text-navy/50 mb-3 mt-1">{subtitle}</p>}
        <div className="space-y-3 mt-2">
          <div><label className="text-xs text-navy/60">Motivo de cancelación (SAT)</label>
            <select data-testid="cancel-motive" value={motive} onChange={(e) => setMotive(e.target.value)} className={input}>{MOTIVOS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select></div>
          {motive === "01" && (
            <div><label className="text-xs text-navy/60">UUID del CFDI que lo sustituye</label>
              <input data-testid="cancel-substitution" value={sub} onChange={(e) => setSub(e.target.value)} className={input} placeholder="XXXXXXXX-XXXX-..." /></div>
          )}
        </div>
        <button data-testid="cancel-confirm" onClick={confirm} disabled={busy} className="mt-5 w-full rounded-full bg-destructive text-white py-3 hover:opacity-90 disabled:opacity-50 inline-flex items-center justify-center gap-2">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Ban className="w-4 h-4" />} Cancelar ante el SAT</button>
      </motion.div>
    </div>
  );
}
